var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "verify-main",
    attrs: {
      "ma-0": "",
      "pa-3": "",
      "row": "",
      "justify-center": "",
      "align-start": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "verify-wrapper d-flex flex-column align-stretch",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg4": "",
      "xl3": "",
      "pa-3": ""
    }
  }, [_c('div', {
    staticClass: "verify-card"
  }, [_c('h1', {
    staticClass: "verify-title"
  }, [_vm._v("E-mail verification code")]), _c('p', {
    staticClass: "verify-instructions"
  }, [_vm._v(" We've sent you a 6-digit verification code by email. Enter it below to continue. If you don't see the email, check your spam folder. ")]), _c('form', {
    staticClass: "verify-form d-flex flex-column",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onLogin();
      }
    }
  }, [_c('div', {
    staticClass: "otp-field"
  }, [_c('div', {
    staticClass: "otp-boxes",
    attrs: {
      "role": "group",
      "aria-label": "6-digit verification code"
    }
  }, _vm._l(_vm.digits, function (digit, index) {
    return _c('input', {
      key: index,
      ref: 'otpInput' + index,
      refInFor: true,
      staticClass: "otp-box",
      class: {
        'otp-box--error': !!_vm.errorMessage
      },
      attrs: {
        "type": "text",
        "inputmode": "numeric",
        "pattern": "[0-9]*",
        "autocomplete": "one-time-code",
        "maxlength": "1",
        "aria-label": 'Digit ' + (index + 1),
        "aria-invalid": !!_vm.errorMessage
      },
      domProps: {
        "value": digit
      },
      on: {
        "input": function ($event) {
          return _vm.onDigitInput(index, $event);
        },
        "keydown": function ($event) {
          return _vm.onDigitKeydown(index, $event);
        },
        "paste": function ($event) {
          $event.preventDefault();
          return _vm.onPaste($event);
        },
        "focus": function ($event) {
          return _vm.onDigitFocus($event);
        }
      }
    });
  }), 0), _vm.errorMessage ? _c('div', {
    staticClass: "otp-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _c('v-btn', {
    staticClass: "verify-btn",
    attrs: {
      "type": "submit",
      "loading": _vm.loading,
      "disabled": _vm.loading || _vm.otp_token.length !== 6
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onLogin();
      }
    }
  }, [_vm._v("Verify")])], 1), _c('router-link', {
    staticClass: "verify-back-link",
    attrs: {
      "to": {
        name: 'Login'
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.handleGoBack.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    staticClass: "back-arrow",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Back to Login ")], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }